module.exports = __webpack_public_path__ + "img/services.a17fe825.png";